if (!customElements.get('vk-smooth-accordion')) {
  class VkSmoothAccordion extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.animateEl = this.querySelector('.vk-accgrp-animate, .vk-faq-animate');
      if (!this.details || !this.summary || !this.animateEl) return;

      this._animation = null;
      this._isClosing = false;
      this._isExpanding = false;

      this.summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (this._isClosing || !this.details.open) {
          this.open();
        } else if (this._isExpanding || this.details.open) {
          this.close();
        }
      });
    }

    open() {
      this.details.style.overflow = 'hidden';
      this.details.open = true;

      window.requestAnimationFrame(() => {
        this._isExpanding = true;
        const endHeight = this.animateEl.scrollHeight + 'px';

        if (this._animation) this._animation.cancel();

        this.animateEl.style.height = '0px';
        this.animateEl.style.overflow = 'hidden';

        this._animation = this.animateEl.animate(
          { height: ['0px', endHeight] },
          { duration: 350, easing: 'ease' }
        );

        this._animation.onfinish = () => this._onAnimationFinish(true);
        this._animation.oncancel = () => { this._isExpanding = false; };
      });
    }

    close() {
      this._isClosing = true;
      const startHeight = this.animateEl.scrollHeight + 'px';

      if (this._animation) this._animation.cancel();

      this.animateEl.style.overflow = 'hidden';

      this._animation = this.animateEl.animate(
        { height: [startHeight, '0px'] },
        { duration: 350, easing: 'ease' }
      );

      this._animation.onfinish = () => this._onAnimationFinish(false);
      this._animation.oncancel = () => { this._isClosing = false; };
    }

    _onAnimationFinish(open) {
      this._animation = null;
      this._isClosing = false;
      this._isExpanding = false;
      this.animateEl.style.height = '';
      this.animateEl.style.overflow = '';
      this.details.style.overflow = '';

      if (!open) {
        this.details.open = false;
      }
    }
  }
  customElements.define('vk-smooth-accordion', VkSmoothAccordion);
}
